import Button from '@components/button'
import Row from '@components/row'
import SvgImage from '@components/svg'
import { SvgProps } from '@components/svg/type'
import { useEffect, useState } from 'react'
import {
  ActionButton,
  BookTypography,
  Content,
  Heading,
  Overlay,
  Tag,
  ToastContainer,
} from './style'
import Column from '@components/column'
import Image from '@components/image'
import Typography from '@components/typography'
import useWindowSize from '@hooks/useWindow'

export interface PopupToastProps {
  isOpen?: boolean
  onClose?: () => void
  heading?: string
  content?: string
  buttonText?: string
  cancelText?: string | null
  onClick?: () => void
  tag?: string | null
  image?: SvgProps['src']
  imageLink?: string
  loading?: boolean
  bookToast?: boolean
  secondary?: string
}

const PopupToast = ({
  isOpen = false,
  onClose,
  heading,
  content,
  buttonText = 'Okay',
  cancelText = null,
  onClick,
  tag = null,
  image = 'successIcon' as SvgProps['src'],
  imageLink,
  loading,
  bookToast,
  secondary,
}: PopupToastProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const [shouldRender, setShouldRender] = useState(false)
  const { width } = useWindowSize()
  const isMobile = width < 1024
  useEffect(() => {
    if (isOpen) {
      setShouldRender(true)
      // Small delay to ensure the DOM is ready for the animation
      setTimeout(() => setIsVisible(true), 10)
    } else {
      setIsVisible(false)
      // Wait for exit animation to complete before removing from DOM
      const timer = setTimeout(() => setShouldRender(false), 500)
      return () => clearTimeout(timer)
    }
  }, [isOpen])

  const handleButtonClick = () => {
    if (onClick) onClick()
    if (onClose) onClose()
  }

  if (!shouldRender) return null

  return (
    <>
      <Overlay className={isVisible ? 'visible' : 'hidden'} />
      <ToastContainer className={isVisible ? 'visible' : 'hidden'}>
        {imageLink ? (
          <Column styleColumn={{ marginBottom: 12 }}>
            <Image src={imageLink} height={122} width={80} />
          </Column>
        ) : (
          <Column styleColumn={{ marginBottom: 12 }}>
            <SvgImage src={image} />
          </Column>
        )}
        {bookToast ? (
          <>
            <BookTypography>
              {content} <span>{tag}</span>
            </BookTypography>
            <Typography tc={'greyText'} size={14} weigth={300}>
              {secondary}
            </Typography>
          </>
        ) : (
          <>
            {heading && <Heading>{heading}</Heading>}
            {content && <Content>{content}</Content>}
            {tag && <Tag>{tag}</Tag>}
          </>
        )}

        {!!cancelText ? (
          <Row colGap={10} styleRow={{ width: '80%' }}>
            <Column styleColumn={{ width: '48%' }}>
              <Button outline title={cancelText} onClick={onClose} />
            </Column>
            <Column styleColumn={{ width: '48%' }}>
              <Button
                title={buttonText}
                onClick={handleButtonClick}
                loading={loading}
              />
            </Column>
          </Row>
        ) : (
          <Row colGap={10} styleRow={{ width: isMobile ? '100%' : '40%' }}>
            <ActionButton onClick={handleButtonClick}>
              {buttonText}
            </ActionButton>
          </Row>
        )}
      </ToastContainer>
    </>
  )
}

export default PopupToast
